<div class="actions is-flex has-flex-align-center has-flex-content-space-between has-flex-wrap" [class.commercial]="listing.isCommercial">
  <a (click)="toggleMap.emit()" [class.enabled]="showMap" role="button" tabindex="0" (keydown.enter)="toggleMap.emit()">
    <svg ngNonBindable xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 92 85"><title>Map icon_blue@1x</title>
      <desc></desc>
      <defs>
        <filter x="-24.1%" y="-21.5%" width="148.3%" height="142.9%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="5"/>
        </filter>
        <rect x=".92368" y=".38595" width="74.013" height="64.015" rx="4"/>
        <filter x="-6.8%" y="-7.8%" width="118.9%" height="121.9%">
          <feOffset dx="2" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
          <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
        </filter>
      </defs>
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(6 12.224)">
          <path transform="translate(37.93 31.409) rotate(90) translate(-37.93 -31.409)" d="m10.845-3.5534h58.171l-62.171 69.924v-65.924c0-2.2091 1.7909-4 4-4z" fill="#F2F2F2" filter="url(#c)" opacity=".4"/>
          <use fill="black" filter="url(#b)"/>
          <use fill="#FFFFFF" fill-rule="evenodd"/>
          <path d="m24.239 37.793h29.238c1.4912 0 2.7 1.2088 2.7 2.7v9.4909c0 1.4912-1.2088 2.7-2.7 2.7h-29.238c-1.4912 0-2.7-1.2088-2.7-2.7v-1.7726-7.7183c0-1.4912 1.2088-2.7 2.7-2.7zM14.174 41.795 14.174 41.795 14.174 41.795 14.174 41.795" fill="#fff"/>
          <path d="m14.174 41.795l5.9951-5.983" stroke="#007DC3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          <path d="m58.137 40.465l4.9425-3.8364" stroke="#007DC3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          <polyline transform="translate(38.174 37.806) scale(-1 1) translate(-38.174 -37.806)" points="22.833 41.13 42.864 41.13 53.515 34.482" stroke="#007DC3" stroke-linecap="square" stroke-width="2"/>
          <path d="m24.239 15.157c-0.93888 0-1.7 0.76112-1.7 1.7v31.162c0 0.93888 0.76112 1.7 1.7 1.7h29.238c0.93888 0 1.7-0.76112 1.7-1.7v-31.162c0-0.93888-0.76112-1.7-1.7-1.7h-29.238zM58.227 14.626 58.227 14.626 58.227 14.626 58.227 14.626" stroke="#007DC3" stroke-width="2"/>
          <path d="m58.227 14.626v33.961l5.3804-4.4746c0.38836-0.32298 0.61299-0.80194 0.61299-1.3071v-32.418c0-0.081758-0.028622-0.16094-0.0809-0.2238-0.1236-0.14862-0.34428-0.1689-0.4929-0.045303l-5.4196 4.5072z" stroke="#007DC3" stroke-width="2"/>
          <path d="m19.489 50.253v-33.961l-5.3804 4.4746c-0.38836 0.32298-0.61299 0.80194-0.61299 1.3071v32.418c0 0.081758 0.028622 0.16094 0.0809 0.2238 0.1236 0.14862 0.34428 0.1689 0.4929 0.045303l5.4196-4.5072z" stroke="#007DC3" stroke-width="2"/>
          <path d="m39.041 46.683c3.9567-6.5015 5.9351-10.843 5.9351-13.023 0-3.2713-2.6572-5.9231-5.9351-5.9231-3.2779 0-5.9351 2.6519-5.9351 5.9231 0 2.1808 1.9784 6.522 5.9351 13.023z" fill="#fff" stroke="#007DC3" stroke-width="1.701"/>
          <ellipse cx="39.041" cy="33.607" rx="2.3914" ry="2.3865" stroke="#007DC3" stroke-width="1.701"/>
        </g>
      </g>
    </svg>
    {{ 'details.map' | translate }}
  </a>
  <a class="hide-on-mobile poi-btn" [class.inactive]="!hasPoi" (click)="hasPoi && goToPoi.emit()" *ngIf="!listing.isCommercial" role="button" [tabindex]="hasPoi ? 0 : -1" (keydown.enter)="goToPoi.emit()">
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 82 72"><title>POI icon_blue@1x</title>
      <desc></desc>
      <defs>
        <rect x="0" y="0" width="74" height="64" rx="4"/>
        <filter x="-6.8" y="-7.8" width="118.9" height="121.9">
          <feOffset dx="2" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
          <feColorMatrix in="shadowBlurOuter1" values="0"/>
        </filter>
      </defs>
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(2.2744 2.2238)">
          <use fill="black" filter="url(#b)"/>
          <use fill="#FFFFFF" fill-rule="evenodd"/>
          <path d="m20.5 15.3c-1.4 0-2.6 1.2-2.6 2.6v22.9c0 1.4 1.2 2.6 2.6 2.6h10.4 0.6l0.3 0.5c1.5 2.8 2.8 4.9 3.8 6.2 0.9 1.2 1.6 1.7 1.9 1.7 0.3 0 1-0.6 1.9-1.7 1.1-1.4 2.4-3.5 3.9-6.2l0.3-0.5h10.9c1.4 0 2.6-1.2 2.6-2.6v-22.9c0-1.4-1.2-2.6-2.6-2.6h-34.1z" stroke="#007DC3" stroke-width="2"/>
          <g transform="translate(27.647 22.166)" id="hat-g" fill="#007DC3">
            <path d="m3.4 8.6v3.4l6 3.2 6-3.2v-3.4l-6 3.2-6-3.2zm6-8.6l-9.4 5.1 9.4 5.1 7.7-4.2v5.9h1.7v-6.8l-9.4-5.1z"/>
          </g>
        </g>
      </g>
    </svg>
    {{ 'details.poi' | translate }}
  </a>
  <a class="video-link" [class.inactive]="!listing.videoUrl" [attr.href]="listing.videoUrl" target="_blank" rel="noopener">
    <svg ngNonBindable xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 82 72"><title>Video icon_blue@1x</title>
      <desc></desc>
      <defs>
        <rect x="0.5" y="0.6" width="74" height="64" rx="4"/>
        <filter x="-6.8" y="-7.8" width="118.9" height="121.9">
          <feOffset dx="2" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
          <feColorMatrix in="shadowBlurOuter1" values="0"/>
        </filter>
      </defs>
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(1.5488 1.2238)">
          <use fill="black" filter="url(#b)"/>
          <use fill="#FFFFFF" fill-rule="evenodd"/>
          <g transform="translate(13.996 19.656)">
            <rect x="1.3" y="1.7" width="31.4" height="22.4" rx="3" stroke="#007DC3" stroke-width="2"/>
            <path d="m33.2 11.2l11-6.2c0.7-0.4 1.6-0.2 2 0.6 0.1 0.2 0.2 0.5 0.2 0.7v12.8c0 0.8-0.7 1.5-1.5 1.5-0.2 0-0.4 0-0.6-0.1l-10.9-4.9-0.2-4.4z" stroke="#007DC3" stroke-width="2"/>
            <polygon points="21.2 12.7 15 17.3 15 8.1" fill="#007DC3"/>
          </g>
        </g>
      </g>
    </svg>
    {{ 'details.video' | translate }}
  </a>
  <a [class.inactive]="!listing.virtualTourUrl" [attr.href]="listing.virtualTourUrl" target="_blank" rel="noopener">
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 83 72"><title>Virtual Tour icon_blue@1x</title>
      <desc></desc>
      <defs>
        <rect x=".51024" y=".016633" width="74.013" height="64.015" rx="4"/>
        <filter x="-6.8%" y="-7.8%" width="118.9%" height="121.9%">
          <feOffset dx="2" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
          <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
        </filter>
      </defs>
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(1.9365 2.2238)">
          <use fill="black" filter="url(#b)"/>
          <use fill="#FFFFFF" fill-rule="evenodd"/>
          <g transform="translate(16.018 11.062)">
            <path d="m40.955 23.284c0 9.17-7.4483 16.603-16.636 16.603-9.1878 0-16.636-7.4325-16.636-16.603 0-9.1692 7.4483-16.603 16.636-16.603 9.1878 0 16.636 7.4333 16.636 16.603zM37.995 21.314 37.995 21.314"/>
            <path d="m37.995 21.314c0 9.17-7.4483 16.603-16.636 16.603-9.1878 0-16.636-7.4325-16.636-16.603 0-9.1692 7.4483-16.603 16.636-16.603 9.1878 0 16.636 7.4333 16.636 16.603z" stroke="#2E2F2E" stroke-width="1.5"/>
            <path d="m37.995 21.314c0 9.17-7.4483 16.603-16.636 16.603-9.1878 0-16.636-7.4325-16.636-16.603 0-9.1692 7.4483-16.603 16.636-16.603 9.1878 0 16.636 7.4333 16.636 16.603z" stroke="#007DC3" stroke-width="2"/>
            <path d="m42.733 20.962c0 11.423-9.5029 20.682-21.225 20.682-11.722 0-21.225-9.2587-21.225-20.682 0-11.422 9.5029-20.682 21.225-20.682 11.722 0 21.225 9.2597 21.225 20.682z" stroke="#007DC3" stroke-dasharray="3,3,3" stroke-width="1.5"/>
            <path d="m37.995 21.314c0 5.3313-7.4483 9.6526-16.636 9.6526-9.1878 0-16.636-4.3213-16.636-9.6526 0-5.3306 7.4483-9.6526 16.636-9.6526 9.1878 0 16.636 4.3221 16.636 9.6526z" stroke="#007DC3" stroke-width="1.5"/>
            <path d="m37.995 21.314c0 5.3313-7.4483 9.6526-16.636 9.6526-9.1878 0-16.636-4.3213-16.636-9.6526 0-5.3306 7.4483-9.6526 16.636-9.6526 9.1878 0 16.636 4.3221 16.636 9.6526z" stroke="#007DC3" stroke-width="1.5"/>
            <path d="m21.359 4.7117c5.3414 0 9.6722 7.4333 9.6722 16.603 0 9.17-4.3308 16.603-9.6722 16.603s-9.6722-7.4325-9.6722-16.603c0-9.1692 4.3308-16.603 9.6722-16.603z" stroke="#007DC3" stroke-width="1.5"/>
            <path d="m21.359 4.7117c5.3414 0 9.6722 7.4333 9.6722 16.603 0 9.17-4.3308 16.603-9.6722 16.603s-9.6722-7.4325-9.6722-16.603c0-9.1692 4.3308-16.603 9.6722-16.603z" stroke="#007DC3" stroke-width="1.5"/>
            <text fill="#007DC3" font-family="Roboto-Medium, Roboto" font-size="7.5" font-weight="400" letter-spacing="-.375" line-spacing="4.5">
              <tspan x="15.3295641" y="26.8059156">360&#730;</tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
    {{ 'details.virtual-tour' | translate }}
  </a>
  <a class="hide-on-mobile" (click)="showExpandedGalleryView.emit()" role="button" tabindex="0" (keydown.enter)="showExpandedGalleryView.emit()">
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 82 71"><title>Gallery icon_blue@1x</title>
      <desc></desc>
      <defs>
        <rect x="0.8" y="1" width="74" height="63.1" rx="4"/>
        <filter x="-6.8" y="-7.9" width="118.9" height="122.2">
          <feOffset dx="2" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
          <feColorMatrix in="shadowBlurOuter1" values="0"/>
        </filter>
      </defs>
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(1.4727 1.2238)">
          <use fill="black" filter="url(#b)"/>
          <use fill="#FFFFFF" fill-rule="evenodd"/>
          <path d="m39.7 40.4l7.8-12.9c0.2-0.3 0.6-0.4 0.9-0.2 0.1 0.1 0.2 0.2 0.3 0.3l6.6 15.2c0.1 0.3 0 0.7-0.4 0.9-0.1 0-0.2 0.1-0.3 0.1h-13.7c-0.1 0-0.2 0.1-0.3 0.1h-12.1c-0.4 0-0.7-0.3-0.7-0.7 0-0.1 0-0.2 0.1-0.3l5.1-10.4c0.2-0.3 0.6-0.5 0.9-0.3 0.1 0.1 0.2 0.1 0.3 0.2l5.4 8zm-13.5-9.2c-1.6 0-2.8-1.2-2.8-2.8s1.3-2.8 2.8-2.8c1.6 0 2.8 1.2 2.8 2.8s-1.3 2.8-2.8 2.8z" fill="#fff" stroke="#007DC3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
          <rect x="19.7" y="20.8" width="39.7" height="26.5" rx="1.6" stroke="#007DC3" stroke-width="1.8"/>
          <path d="m16.8 44.7c-0.9 0-1.6-0.7-1.6-1.6v-25.1c0-0.9 0.7-1.6 1.6-1.6h38.3c0.9 0 1.6 0.7 1.6 1.6" stroke="#007DC3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
        </g>
      </g>
    </svg>
    {{ 'details.gallery' | translate }}
  </a>
</div>
